(() => { 'use strict'; const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>[...r.querySelectorAll(s)]; if(!$('.gallery-track'))return; const open=d=>d.showModal();
  const gallery=JSON.parse($('#pawtuli-gallery').textContent);
  const track=$('.gallery-track');
  const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
  let index=0,galleryWidth=track.clientWidth;
  function syncGallery(){
    // A resize must not reinterpret the old scroll offset using the new photo width.
    if(!galleryWidth||track.clientWidth!==galleryWidth)return;
    index=Math.max(0,Math.min(gallery.length-1,Math.round(track.scrollLeft/galleryWidth)));
    $('#photo-number').textContent=index+1;
    $$('[data-gallery-index]').forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));
  }
  function select(n){
    const target=Math.max(0,Math.min(gallery.length-1,n));
    track.scrollTo({left:target*track.clientWidth,behavior:reducedMotion.matches?'auto':'smooth'});
  }
  track.addEventListener('scroll',syncGallery,{passive:true});
  $$('[data-gallery-index]').forEach(b=>b.addEventListener('click',()=>select(Number(b.dataset.galleryIndex))));
  $('.gallery-main').addEventListener('keydown',e=>{
    if(e.key==='ArrowRight'){e.preventDefault();select(index+1);}
    if(e.key==='ArrowLeft'){e.preventDefault();select(index-1);}
  });
  // Touch uses native scrolling: the image moves continuously with the finger.
  // Mouse dragging provides the same direct movement without changing mobile touch behaviour.
  let drag=null,suppressClick=false;
  track.addEventListener('pointerdown',e=>{
    suppressClick=false;
    if(e.pointerType!=='mouse'||e.button!==0)return;
    drag={id:e.pointerId,x:e.clientX,left:track.scrollLeft,moved:false};
  });
  track.addEventListener('pointermove',e=>{
    if(!drag||drag.id!==e.pointerId)return;
    const delta=e.clientX-drag.x;
    if(!drag.moved&&Math.abs(delta)>5){
      drag.moved=true;track.setPointerCapture(e.pointerId);track.classList.add('is-dragging');
    }
    if(drag.moved){e.preventDefault();track.scrollLeft=drag.left-delta;}
  });
  function finishDrag(e){
    if(!drag||drag.id!==e.pointerId)return;
    const moved=drag.moved;
    drag=null;track.classList.remove('is-dragging');
    if(track.hasPointerCapture(e.pointerId))track.releasePointerCapture(e.pointerId);
    if(moved){suppressClick=true;select(Math.round(track.scrollLeft/track.clientWidth));}
  }
  track.addEventListener('pointerup',finishDrag);
  track.addEventListener('pointercancel',finishDrag);
  track.addEventListener('pointerleave',e=>{if(drag&&!drag.moved)drag=null;});
  track.addEventListener('dragstart',e=>e.preventDefault());
  track.addEventListener('click',e=>{
    if(suppressClick){e.preventDefault();e.stopPropagation();suppressClick=false;return;}
    const slide=e.target.closest('[data-slide-index]');if(!slide)return;
    const photo=gallery[Number(slide.dataset.slideIndex)];
    $('#zoom-image').src=photo.src;$('#zoom-image').alt=photo.alt;open($('#zoom-dialog'));
  });
  new ResizeObserver(()=>{
    const nextWidth=track.clientWidth;
    if(!nextWidth||nextWidth===galleryWidth)return;
    galleryWidth=nextWidth;
    track.scrollTo({left:index*galleryWidth,behavior:'instant'});
  }).observe(track);

})();